export default __webpack_public_path__ + "static/PAPC-195-46258e032b3fd5b4d5b2e334f4dd2145.jpg";